import { useActor } from '@xstate/react';
import { useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { formatEther, parseEther } from 'viem';
import { MachineContext } from '../contexts/machine';

export function BalanceAfterTopUp() {
  const interpreter = useContext(MachineContext);
  const [state] = useActor(interpreter);
  const target = state.context.target!;
  const { control } = useFormContext();
  const amount = useWatch({ control, name: 'amount' });
  return (
    <>{formatEther(parseEther(target.effectiveBalance) + parseEther(amount))}</>
  );
}
